import {
	GET_JOURNAL_VOUCHER_REQUEST,
	GET_JOURNAL_VOUCHER_SUCCESS,
	GET_JOURNAL_VOUCHER_ERROR,
} from "../actions/types";
export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_JOURNAL_VOUCHER_REQUEST:
			return {
				loading: true,
			};
		case GET_JOURNAL_VOUCHER_SUCCESS:
			return {
				...state,
				loading: false,
				payload: payload,
			};
		case GET_JOURNAL_VOUCHER_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};
		default:
			return state;
	}
}
